import type { GridLocaleText } from '@mui/x-data-grid-pro';
import { csCZ, enUS, hrHR, huHU, itIT, roRO, skSK } from '@mui/x-data-grid/locales';

const DATA_GRID_LOCALES: Partial<Record<string, typeof enUS>> = {
  en: enUS,
  hu: huHU,
  ro: roRO,
  sk: skSK,
  cz: csCZ,
  hr: hrHR,
  sr: enUS,
  sl: enUS,
  it: itIT,
};

export function getDataGridLocaleText(language: string): Partial<GridLocaleText> {
  const normalizedLanguage = language.toLowerCase().split('-')[0];
  const locale = DATA_GRID_LOCALES[normalizedLanguage] ?? enUS;

  return locale.components.MuiDataGrid.defaultProps.localeText;
}
